"use client";

import { useEffect, useState } from "react";
import { Center, Text } from "@mantine/core";
import Lottie from "lottie-react";
import loadingAnim from "../../../public/confetti/DNA_Loop.json";

export default function Loading() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  if (!mounted)
    return (
      <Center
        style={{
          width: "100%",
          height: "100vh",
          background: "linear-gradient(180deg, #f7fafc 0%, #ffffff 100%)",
        }}
      />
    );

  return (
    <Center
      style={{
        width: "100%",
        height: "100vh",
        flexDirection: "column",
        backgroundColor: "#fafafa",
      }}
    >
      <Lottie animationData={loadingAnim} loop autoplay style={{ width: 200, height: 200 }} />
      <Text mt="sm" c="dimmed" fz="sm">
        Loading Variant...
      </Text>
    </Center>
  );
}
